module.exports = __webpack_public_path__ + "static/media/correct.d2267497.png";